// src/redux/reducers/matchesReducer.js

const initialState = {
  list: [
  ],
  selectedMatch: null, // Match actuellement ouvert
  matchesDonneurOrdre: [],
  selectedMatchDonneurOrdre: null,


};

const matchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MATCHES":
      return { ...state, list: action.payload };
    case "SET_MATCHES_DONNEUR_ORDRE":
      return { ...state, matchesDonneurOrdre: action.payload };
    case "ADD_MATCH":
      return { ...state, list: [...state.list, action.payload] };
    case "ADD_MATCH_DONNEUR_ORDRE":
      return { ...state, matchesDonneurOrdre: [...state.matchesDonneurOrdre, action.payload] };
    case "SELECT_MATCH":
      return { ...state, selectedMatch: action.payload };
    case "SELECT_MATCH_DONNEUR_ORDRE":
      return { ...state, selectedMatchDonneurOrdre: action.payload };

    case "MARK_MESSAGES_READ":
      return {
        ...state,
        list: state.list.map((m) =>
          m.id === action.payload ? { ...m, unread: 0 } : m
        ),
      };

    case "ADD_MESSAGE_TO_MATCH":
      return {
        ...state,
        list: state.list.map((m) =>
          m.id === action.payload.matchId
            ? {
              ...m,
              messages: [...m.messages, action.payload.message],
              lastMessage: action.payload.message.content,
              unread:
                state.selectedMatch?.id === m.id
                  ? m.unread // si match ouvert → pas d’unread supplémentaire
                  : (m.unread || 0) + 1,
            }
            : m
        ),
      };
    case "ADD_MESSAGE_TO_MATCH_DONNEUR_ORDRE":
      return {
        ...state,
        matchesDonneurOrdre: state.matchesDonneurOrdre.map((m) =>
          m.matchId === action.payload.matchId
            ? {
              ...m,
              messages: [...m.messages, action.payload.message],
              lastMessage: action.payload.message.content,
              unread:
                state.selectedMatch?.id === m.id
                  ? m.unread // si match ouvert → pas d’unread supplémentaire
                  : (m.unread || 0) + 1,
            }
            : m
        ),
      };
    case "UPDATE_MATCH_MESSAGES":
      return {
        ...state,
        list: state.list.map((m) =>
          m.id === action.payload.matchId
            ? { ...m, messages: action.payload.messages }
            : m
        ),
        selectedMatch:
          state.selectedMatch?.id === action.payload.matchId
            ? { ...state.selectedMatch, messages: action.payload.messages }
            : state.selectedMatch,
      };

    case "UPDATE_MATCH_MESSAGES_DONNEUR_ORDRE":
      return {
        ...state,
        matchesDonneurOrdre: state.matchesDonneurOrdre.map((m) =>
          m.id === action.payload.matchId
            ? { ...m, messages: action.payload.messages }
            : m
        ),
        selectedMatchDonneurOrdre:
          state.selectedMatchDonneurOrdre?.id === action.payload.matchId
            ? { ...state.selectedMatchDonneurOrdre, messages: action.payload.messages }
            : state.selectedMatchDonneurOrdre,
      };

    default:
      return state;
  }
};

export default matchReducer;
